const getSiteId = state => state.user.currentUser.siteId;
const getApiKey = state => state.user.currentUser.apiKey;
const getAuth = state => state.user.auth;

export { getApiKey, getSiteId, getAuth };



// WEBPACK FOOTER //
// ./src/sagas/selectors/index.js